import { OSKIconDefinition } from '../osk-icon.types';

export const oskIconSearch: OSKIconDefinition = {
  name: 'search',
  content: '<circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" />'
};
